import { styled, MenuItem, MenuItemProps } from '@mui/material'

const AvantMenuItem = styled((props: MenuItemProps) => {
    return <MenuItem {...props} />
})(() => ({}))

export default AvantMenuItem